<button class="btn btn-sm btn-outline-secondary" data-toggle="modal" [attr.data-target]="'#TinyImage' + id" (drop)="drop($event)" (dragover)="allowDrop($event)"><i class="fa-solid fa-image"></i> {{ 'Buttons.Add' | translate }} {{ ('Standard.Image' | translate) | lowercase }}</button>

<div [attr.id]="'TinyImage' + id" class="modal fade">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header p-3">
                <h3>{{ 'Buttons.ChooseSingleImage' | translate }}</h3>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <i class="fa fa-window-close red" aria-hidden="true"></i>
                </button>
            </div>
            <div class="modal-body pl-3 pr-3">
                <div class="preExisting" *ngFor="let f of files" (click)="preExistingFileClick($event)" data-dismiss="modal">
                    <img src="{{'https://jubloapi.azure-api.net/api/shared/attachments/' + f}}" alt="File image">
                </div>
            </div>
            <div class="modal-footer p-3">
                <button class="btn btn-sm btn-primary" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
            </div>
        </div>
    </div>
</div>
